import React, {ReactNode} from "react";
import './card.scss';

interface Props {
    children: ReactNode,
    className?: string,
    backgroundColor?: string,
    greyBorder?: boolean,
    shadow?: boolean,
    [x: string]: any,
}

const Card = ({
    children,
    className,
    backgroundColor = "#FFF",
    greyBorder,
    shadow,
    ...rest
}: Props) => {
    const borderClass = greyBorder ? 'greyBorder' : '';
    const shadowClass = shadow ? 'shadow' : '';
    return (
        <div
            className={[className, 'card', borderClass, shadowClass].join(' ')}
            style={{
                backgroundColor,
            }}
            {...rest}
        >
            {children}
        </div>
    );
};

export default Card;